export const CELLS_OUTLINE_LAYER_ID = 'cells-outline';
export const CELLS_FILL_LAYER_ID = 'cells-fill';
export const PLOT_CELLS = 'plot-cells';
export const INTERACTIVE_LAYERS = [CELLS_OUTLINE_LAYER_ID, CELLS_FILL_LAYER_ID];
export const COMBINED_LAYER_SOURCE_ID = 'combined-layer-source';
export const COMBINED_LAYER_FILL_LAYER_ID = 'combined-layer-fill-layer';
